import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import pngwing from "../../Assets/Logo/pngwing.png";
import { useNavigate } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import {  useLocation } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import AutoGraphIcon from "@mui/icons-material/AutoGraph"; 

const Header = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
const open = Boolean(anchorEl);
const location = useLocation();


const handleProfileClick = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleClose = () => {
  setAnchorEl(null);
};

const handleLogout = () => {
  localStorage.removeItem("isLoggedIn");
  setIsLoggedIn(false); // update local state
  handleClose();
  navigate("/login");
};



  useEffect(() => {
  const loggedIn = localStorage.getItem("isLoggedIn") === "true";
  setIsLoggedIn(loggedIn);
}, []);


  const menuItems = [
  { text: "Home", path: "/", icon: <HomeIcon /> },
  { text: "Contact Us", path: "/contact", icon: <ContactMailIcon /> },
  ...(isLoggedIn ? [{ text: "Levels", path: "/levels", icon: <AutoGraphIcon /> }] : []),
];

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleNavigate = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  // Handle scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10); // adjust threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: scrolled
            ? "white" // semi-transparent when scrolled
            : "transparent",
          backdropFilter: scrolled ? "blur(100px)" : "transparent",
          boxShadow: scrolled ? "0 4px 12px rgba(0, 0, 0, 0.15)" : "none",

          transition: "background-color 0.3s ease, box-shadow 0.3s ease",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box display="flex" alignItems="center" mb={1}>
            <img
              src={pngwing}
              alt="Logo"
              style={{ height: 50, marginRight: 10 }}
            />
          </Box>

          {/* <Typography
            variant="h6"
            sx={{ color: "black", fontWeight: "bold", cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            Yoga
          </Typography> */}

          <Box
  sx={{
    display: { xs: "none", md: "flex" },
    gap: 3,
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
  }}
>
  {menuItems.map((item) => {
    const isActive = location.pathname === item.path;
    return (
      <Button
        key={item.text}
        onClick={() => handleNavigate(item.path)}
        sx={{
          color: "black",
          fontWeight: "bold",
          textTransform: "none",
          fontSize: "16px",
          backgroundColor: isActive ? "grey" : "transparent",
          "&:hover": {
            backgroundColor: "grey",
          },
        }}
      >
        {item.text}
      </Button>
    );
  })}
</Box>


  <Box display="flex" alignItems="center" gap={1}>
  {isLoggedIn ? (
    <>
      <IconButton
  onClick={handleProfileClick}
  sx={{
    color: "black",
    display: { xs: "none", md: "flex" },
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "white", // hover effect
    },
  }}
>
  <PersonIcon sx={{ color: "black" }} />
</IconButton>

     <Menu
  anchorEl={anchorEl}
  open={open}
  onClose={handleClose}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "right",
  }}
  PaperProps={{
    sx: {
      backgroundColor: "#f0f0f0", // light gray background
    },
  }}
>
  <MenuItem onClick={() => navigate("/profile")}>
    <PersonIcon fontSize="small" sx={{ mr: 1 }} />
    Profile
  </MenuItem>

  <MenuItem onClick={() => navigate("/help")}>
    <HelpOutlineIcon fontSize="small" sx={{ mr: 1 }} />
    Help Center
  </MenuItem>

  <Box sx={{ my: 0.5 }}>
    <hr style={{ borderColor: "#e0e0e0", margin: "4px 0" }} />
  </Box>

  <MenuItem onClick={handleLogout}>
    <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
    Log out
  </MenuItem>
</Menu>
    </>
  ) : (
    <Button
      onClick={() => navigate("/login")}
      sx={{
        color: "black",
        fontWeight: "bold",
        textTransform: "none",
        fontSize: "16px",
        border: "1px solid black",
        borderRadius: "30px",
        px: 2,
      }}
    >
      Login
    </Button>
  )}

  <IconButton
    edge="end"
    color="inherit"
    onClick={toggleDrawer(true)}
    sx={{ display: { xs: "flex", md: "none" } }}
  >
    <MenuIcon sx={{ color: "black" }} />
  </IconButton>
</Box>


        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile */}
    <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
      <Box
        sx={{
          width: 250,
          backgroundColor: "#e0e0e0",
          height: "100vh",
        }}
        role="presentation"
        onKeyDown={toggleDrawer(false)}
      >
        {/* Close Icon */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            px: 2,
            py: 1,
            borderBottom: "1px solid rgba(255,255,255,0.2)",
          }}
        >
          <IconButton onClick={toggleDrawer(false)} sx={{ color: "grey" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <List>
          {/* Profile Option */}
          {isLoggedIn && (
            <ListItem disablePadding>
              <ListItemButton
                sx={{
                  '&:hover': { backgroundColor: "white" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <PersonIcon />
                  <ListItemText primary="Profile" />
                </Box>
              </ListItemButton>
            </ListItem>
          )}

          {/* Navigation Menu Items */}
          {menuItems.map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                onClick={() => handleNavigate(item.path)}
                sx={{
                  '&:hover': { backgroundColor: "white" },
                  ...(location.pathname === item.path && {
                    backgroundColor: "white",
                  }),
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {item.icon}
                  <ListItemText primary={item.text} />
                </Box>
              </ListItemButton>
            </ListItem>
          ))}

          {/* Logout Option */}
          {isLoggedIn && (
            <ListItem disablePadding>
              <ListItemButton
                onClick={handleLogout}
                sx={{
                  '&:hover': { backgroundColor: "white" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <LogoutIcon />
                  <ListItemText primary="Logout" />
                </Box>
              </ListItemButton>
            </ListItem>
          )}
        </List>
      </Box>
    </Drawer>

    </>
  );
};

export default Header;
